import React from "react";
import styles from "./MadeToMeasureReviewModal.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { CurtainConfiguration, HeadingType } from "../../configurationTypes";

type Props = {
  configuration: CurtainConfiguration;
  onClose: (e: React.SyntheticEvent) => void;
};

const CurtainsSelection = ({ configuration, onClose }: Props) => {
  const config = configuration;

  const toCamelCase = (input: string | undefined): string =>
    input
      ?.split(" ")
      .map((word, i) =>
        word
          ? i === 0
            ? word.toLowerCase()
            : word[0]?.toUpperCase() + word.slice(1).toLowerCase()
          : "",
      )
      .join("") || "";

  const headingType = toCamelCase(config.headingType);
  const eyeletColour = toCamelCase(config.eyeletColour);
  const typeOfCurtain = toCamelCase(config.typeOfCurtain);

  return (
    <>
      <li>
        <img
          className={styles.ReviewContent__image}
          src={`https://static.johnlewiscontent.com/v1/static/curtain-heading-${headingType}`}
          aria-label={`Heading Type ${config.headingType}`}
        />
        <div>
          <p className={styles.ReviewContent__title}>Heading style</p>
          <h2 data-testid="m2m-review-config-heading-type">
            {config.headingType}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-curtains-heading-style"
              labelText="edit"
            />
          </h2>
        </div>
      </li>
      {config.headingType === HeadingType.Eyelet && (
        <li>
          <img
            className={styles.ReviewContent__image}
            src={`https://static.johnlewiscontent.com/v1/static/curtain-eyelet-${eyeletColour}`}
            aria-label={`Eyelet colour ${config.eyeletColour}`}
          />
          <div>
            <p className={styles.ReviewContent__title}>Eyelet colour</p>
            <h2 data-testid="m2m-review-config-eyelet-colour">
              {config.eyeletColour}{" "}
              <UnderlinedButton
                tag="a"
                type="button"
                onClick={onClose}
                href="#accordion-m2m-curtains-heading-style"
                labelText="edit"
              />
            </h2>
          </div>
        </li>
      )}
      <li>
        <img
          className={styles.ReviewContent__image}
          src={`https://static.johnlewiscontent.com/v1/static/curtain-type-${typeOfCurtain}`}
        />
        <div>
          <p className={styles.ReviewContent__title}>Measurements</p>
          <h2 data-testid="m2m-review-config-curtain-type">
            {config.typeOfCurtain === "Pair"
              ? "Pair of curtains"
              : "Single curtain"}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-curtains-measurements"
              labelText="edit"
            />
          </h2>
          <h2 data-testid="m2m-review-config-measurements">
            {config.lengthOfTrackOrPole}cm (width) x {config.eyeDrop}cm (drop){" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-curtains-measurements"
              labelText="edit"
            />
          </h2>
        </div>
      </li>

      <li>
        <img
          className={styles.ReviewContent__image}
          src={
            config.liningColour === "Cream"
              ? "https://static.johnlewiscontent.com/v1/static/lining-colour-cream"
              : "https://static.johnlewiscontent.com/v1/static/lining-colour-white"
          }
          aria-label={`Lining Colour ${config.liningColour}`}
        />
        <div>
          <p className={styles.ReviewContent__title}>Lining Options</p>
          <h2 data-testid="m2m-review-config-lining-weight">
            {config.liningWeight === "Blackout"
              ? "Premium Thermal Blackout Lining"
              : "Premium Cotton Lining"}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-curtains-lining-options"
              labelText="edit"
            />
          </h2>
          <p className={styles.ReviewContent__title}>Lining Colour</p>
          <h2 data-testid="m2m-review-config-lining-colour">
            {config.liningColour}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-curtains-lining-options"
              labelText="edit"
            />
          </h2>
        </div>
      </li>
    </>
  );
};

export default CurtainsSelection;
